import { EventStatusEnum } from '@/enums';

/* Same values as `liveEvents` in the API config */
export const EVENT_MIN_DURATION_MINUTES = 60;
export const EVENT_DEFAULT_ROUND_MINUTES = 5;
export const EVENT_DEFAULT_AGE_BUFFER_YEARS = 10;
export const EVENT_MIN_PRICE = 100;
export const EVENT_MAX_PRICE = 10000;

export const EVENT_STATUS_CONFIG: Record<EventStatusEnum, { label: string; className: string }> = {
	[EventStatusEnum.SCHEDULED]: { label: 'Programmé', className: 'bg-blue-100 text-blue-700 hover:bg-blue-100' },
	[EventStatusEnum.LIVE]:      { label: 'En cours',  className: 'bg-green-100 text-green-700 hover:bg-green-100' },
	[EventStatusEnum.ENDED]:     { label: 'Terminé',   className: 'bg-gray-100 text-gray-500 hover:bg-gray-100' },
};
